var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpersonateChange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1186 -1537)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1186 1537)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144.285 1523.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.492,29.935a.54.54,0,0,0,.123.012.639.639,0,0,0,.627-.514.513.513,0,0,0,.01-.1,4,4,0,0,1,7.958,0,.635.635,0,0,0,.628.563h.074a.635.635,0,0,0,.558-.7,5.268,5.268,0,0,0-3.114-4.241,3.207,3.207,0,1,0-4.529-.257,3.3,3.3,0,0,0,.257.257,5.261,5.261,0,0,0-3.1,4.226.635.635,0,0,0,.5.749h.006Zm4.729-9.309a1.942,1.942,0,1,1-1.942,1.943,1.944,1.944,0,0,1,1.942-1.943Z",
    transform: "translate(1.317 0.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.808,24.422a.464.464,0,0,0-.249-.257.47.47,0,0,0-.361-.006l-.682.274a6.307,6.307,0,0,0,.227-1.6,6.451,6.451,0,1,0-12.558,2.06l.222.477v0a.563.563,0,0,0,1.088-.206.546.546,0,0,0-.066-.267h0a5.294,5.294,0,1,1,9.979-.817l-.329-.822a.47.47,0,0,0-.874.349l.86,2.142a.245.245,0,0,0,.068.1.259.259,0,0,0,.272.048l2.141-.859A.47.47,0,0,0,57.808,24.422Z",
    transform: "translate(1.475 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpersonateChange);
export default __webpack_public_path__ + "static/media/impersonate-change.61e33592586415c3d5e4c38aa7c06228.svg";
export { ForwardRef as ReactComponent };